// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"bd38ee5f","161":"a0e335df","239":"e7a2ff17","241":"9e1cdf12","355":"877687e2","396":"6a4ff26f","455":"bc0e83d0","673":"e7dda51e","715":"41f5946a","722":"c4662f89","857":"44e4468d","882":"74670eb8","889":"2a3dd247","977":"a723575a"}[chunkId] + ".chunk.js";
};